// 入力フォームの初期値 (initialValues属性にセットする)
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from 'views/components/atoms/toast/hook';
import { CustomerPagePath } from 'views/constants/enums/pageTitle';
import { useLoginMutation } from 'views/utils/graphql/graphql';
import {
  useEstablishStore,
  useNowEstablishPageTypeStore,
  useIsPrevPageConfirmStore,
} from '../accountEstablishment/hooks';
import { ToastMessageLevel } from 'views/components/atoms/toast';
import useOnceSubmit from 'views/utils/useOnceSubmit';

type LoginParamType = {
  account: '';
  password: '';
};

export const useLogin = () => {
  const [loginlData, login] = useLoginMutation();
  const [isRevealPassword, setRevealPassword] = useState<boolean>(false);
  const navigate = useNavigate();
  const { toastProps, showToast } = useToast();
  const { clear } = useEstablishStore();
  const { reset } = useNowEstablishPageTypeStore();
  const { isPrevPageConfirm, setIsPrevPageConfirm } = useIsPrevPageConfirmStore();

  useEffect(() => {
    setIsPrevPageConfirm(false);
  }, []);

  useEffect(() => {
    clear();
    reset();
  }, [clear, reset]);

  const validate = (values: LoginParamType) => {
    const errors: Partial<{
      account: string;
      password: string;
    }> = {};

    if (!values.account) {
      errors.account = '口座番号が未入力です';
    }
    if (!values.password) {
      errors.password = 'パスワードが未入力です';
    }
    return errors;
  };

  const togglePassword = () => {
    setRevealPassword(!isRevealPassword);
  };

  const onSubmit = useOnceSubmit<LoginParamType>(
    {
      onSubmit: async (values) => {
        const ret = await login({
          input: {
            Account: values.account,
            Password: values.password,
          },
        });

        if (ret.data && ret.data?.Login?.Code !== 0) {
          showToast(ret.data?.Login?.Message ?? 'ログインに失敗しました', ToastMessageLevel.Error);
        } else if (ret.data?.Login?.Code === 0) {
          sessionStorage.setItem('last_4_digits', ret.data.Login.PhoneNumber!);
          navigate(CustomerPagePath.SendSMS, {
            state: {
              phoneNumber: ret.data.Login.PhoneNumber,
              provisionalToken: ret.data.Login.ProvisionalToken,
            },
          });
        }
      },
    },
    [showToast, navigate],
  );

  const formik = useFormik<LoginParamType>({
    initialValues: {
      account: '',
      password: '',
    },
    onSubmit,
    validate,
    validateOnChange: false,
    validateOnBlur: false,
  });

  return { isRevealPassword, togglePassword, formik, toastProps };
};
